import { Component, OnInit, Input, OnChanges, SimpleChanges } from '@angular/core';
import { SocialMediaLink, SocialMediaType, SocialMediaLinkUtilities } from '@fitscovery/partner/data-access';

@Component({
  selector: 'fitscovery-ui-social-media-link',
  templateUrl: './ui-social-media-link.component.html',
  styleUrls: ['./ui-social-media-link.component.scss'],
})
export class UiSocialMediaLinkComponent implements OnInit, OnChanges {
  @Input() socialMediaLink: SocialMediaLink;
  @Input() isRound: boolean;
  @Input() isSmall: boolean;
  @Input() url: string;
  socialMediaType = SocialMediaType;

  constructor() {}

  ngOnInit(): void {
    this.isRound = !this.isRound
      ? false
      : this.isRound;
    this.isSmall = !this.isSmall
      ? false
      : this.isSmall;
  }

  ngOnChanges(changes: SimpleChanges): void {
		this.formatSocialMediaLink();
	}

	formatSocialMediaLink(): void {
		switch (this.socialMediaLink?.socialMediaType) {
			case SocialMediaType.Facebook:
				this.url = SocialMediaLinkUtilities.getFacebookLink(this.socialMediaLink?.url!);
				break;
			case SocialMediaType.Instagram:
				this.url = SocialMediaLinkUtilities.getInstagramLink(this.socialMediaLink?.url!);
				break;
			case SocialMediaType.Twitter:
				this.url = SocialMediaLinkUtilities.getTwitterLink(this.socialMediaLink?.url!);
				break;
			case SocialMediaType.LinkedIn:
				this.url = SocialMediaLinkUtilities.getLinkedInLink(this.socialMediaLink?.url!);
				break;
			case SocialMediaType.Email:
				this.url = SocialMediaLinkUtilities.getEmailLink(this.socialMediaLink?.url!);
				break;
		}
	}
}
